import { Injectable } from '@angular/core';
import { FileSaverService } from './fileSaver.service';

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {
  constructor(private fileSaverService: FileSaverService) {}

  public async exportAsExcelFile(json: any[], excelFileName: string): Promise<void> {
    // Dynamic import, load only when needed as fileSaver.service
    const exceljs = await import('exceljs');
    const workbook = new exceljs.default.Workbook();

    const worksheet = workbook.addWorksheet('data');

    // Add header row
    const headers = Object.keys(json[0]);
    worksheet.addRow(headers);

    // Add data rows
    json.forEach((item) => {
      const row = headers.map((header) => item[header]);
      worksheet.addRow(row);
    });

    // Generate Excel file
    const buffer = await workbook.xlsx.writeBuffer();
    this.saveAsExcelFile(buffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    this.fileSaverService.saveFile(
      data,
      fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
    );
  }
}
